/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetLocationQueryResult } from '../../models/get-location-query-result';

export interface ApiLocationGetLocationGet$Plain$Params {
  Id?: string;
}

export function apiLocationGetLocationGet$Plain(http: HttpClient, rootUrl: string, params?: ApiLocationGetLocationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocationQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationGetLocationGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetLocationQueryResult>;
    })
  );
}

apiLocationGetLocationGet$Plain.PATH = '/api/Location/GetLocation';
